import { useVacancyQuery } from "@generated/graphql";
import PageHeader from "components/PageHeader";
import useIsCreate from "hooks/useIsCreate";
import useSetTabTitle from "hooks/useSetTabTitle";
import { useParams } from "react-router-dom";

const Header = () => {
  const { vacancyId } = useParams();
  const isCreate = useIsCreate();
  const { data } = useVacancyQuery({ variables: { vacancyId: vacancyId! } });

  const vacancy = data?.vacancy;

  const getVacancyTopic = () => {
    if (isCreate) return "";

    return [vacancy?.numericId || "", vacancy?.title || ""].filter((item) => item).join(", ");
  };

  const title = `Вакансия ${getVacancyTopic()}`;

  useSetTabTitle(title, vacancy);

  return <PageHeader title={title} />;
};

export default Header;
